import { Bid, ResolutionSelection } from './Rules';

export enum ActionTypes {
  BID = 'BID',
  RESOLVE = 'RESOLVE',

  UNBID = 'UNBID',
}

export type GameAction =
  | {
      type: ActionTypes.BID;
      bid: Bid;
    }
  | {
      type: ActionTypes.UNBID;
    }
  | {
      type: ActionTypes.RESOLVE;
      resolve: ResolutionSelection;
    };
